// extracted by mini-css-extract-plugin
export default {"comment":"xEnCLPjDVctQxmxponnd","author":"SZVe3g5dCC6mLv3cP_vS"};